import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-border-bottom",
  templateUrl: "./med-icon-border-bottom.component.html",
})
export class MedIconBorderBottomComponent extends SvgMixinComponent {}
